import React, { useEffect, useMemo, useState } from "react";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  ArrowDownward as ArrowDownwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  List as ListIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ChildrenModalContent from "./children-modal";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import metadataService from "../../../services/metaData.service";
import {
  buildSpecialTree,
  flattenSpecialTree,
  getDescendantIds,
  moveSpecialRow,
  normalizeSpecialTree,
  ROOT_PARENT_ID,
  stripSpecialTree,
} from "./helpers";

const defaultKeys = [
  {
    title: "نام",
    field: "title",
    active: true,
  },
];

export default function SpecialSettingPage() {
  const [treeData, setTreeData] = useState([]);

  const data = useMemo(() => flattenSpecialTree(treeData), [treeData]);

  const saveRows = async (rows) => {
    const nextTree = buildSpecialTree(rows);
    await metadataService.setMetaData("special", stripSpecialTree(nextTree));
    onRefresh();
  };

  const deleteItem = async (item) => {
    const descendantIds = getDescendantIds(data, item.id);
    const rowsWithoutItemAndChildren = data.filter(
      (row) => row.id !== item.id && !descendantIds.has(row.id),
    );
    await saveRows(rowsWithoutItemAndChildren);
  };

  const getRootIndex = (row) => {
    return data
      .filter((item) => item.parentId === ROOT_PARENT_ID)
      .findIndex((item) => item.id === row.id);
  };

  const moveRootItem = async (row, direction) => {
    await saveRows(moveSpecialRow(data, row.id, direction));
  };

  const headerCells = useMemo(
    () => [
      {
        field: "displayTitle",
        title: "عنوان",
        mainField: false,
      },
      {
        field: "href",
        title: "لینک",
        mainField: false,
      },
      {
        field: "level",
        title: "سطح",
        mainField: false,
      },
    ],
    [],
  );

  useEffect(() => {
    onRefresh();
  }, []);

  const onRefresh = async () => {
    const { data, error } = await metadataService.getMetaData("special");
    if (error) return;
    setTreeData(normalizeSpecialTree(data?.special || []));
  };

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        data={data}
        order={{ order: "ASC", orderBy: "index" }}
        onRefresh={onRefresh}
        rowActions={[
          {
            icon: <ArrowUpwardIcon />,
            tooltip: "Ø§Ù†ØªÙ‚Ø§Ù„ Ø¨Ù‡ Ø¨Ø§Ù„Ø§",
            hidden: (row) => row.level !== 0,
            disabled: (row) => getRootIndex(row) <= 0,
            onClick: (row) => moveRootItem(row, -1),
          },
          {
            icon: <ArrowDownwardIcon />,
            tooltip: "Ø§Ù†ØªÙ‚Ø§Ù„ Ø¨Ù‡ Ù¾Ø§ÛŒÛŒÙ†",
            hidden: (row) => row.level !== 0,
            disabled: (row) => {
              const rootItems = data.filter((item) => item.parentId === ROOT_PARENT_ID);
              const index = rootItems.findIndex((item) => item.id === row.id);
              return index === -1 || index >= rootItems.length - 1;
            },
            onClick: (row) => moveRootItem(row, 1),
          },
          {
            modalProps: { maxWidth: "md" },
            icon: <ListIcon />,
            tooltip: "زیرمجموعه‌ها",
            hidden: (row) => row.level >= 2,
            modalContent: (props) => (
              <ChildrenModalContent
                allSpecials={data}
                onSave={saveRows}
                {...props}
              />
            ),
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => (
              <FormModalContent allSpecials={data} onSave={saveRows} {...props} />
            ),
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.title}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد ویژه",
            modalContent: (props) => (
              <FormModalContent allSpecials={data} onSave={saveRows} {...props} />
            ),
          },
        ]}
        searchKeys={defaultKeys}
        title="مدیریت لیست های ویژه"
      />
    </div>
  );
}
